import ApiOff from './apioff'

/******************************************************************************
 *  Configurations Offline
 *****************************************************************************/

/**
 * @type {Offline}
 */
export default class Offline extends ApiOff {

    getConfigurations() {
        return this.http.get('/configurations')
    }

    getLabels() {
        return this.http.get('/configurations')
            .then(response => {
                let data = { ...response.data }
                data = Object.values(data).filter(config => config.name && config.name.includes('label'))
                    .map(config => {
                        return { value: config.value, label: config.value }
                    })
                response.data = { ...data }

                return response
            })
    }

    getTeams() {
        return this.http.get('/teams')
    }

    getManagerByTeam(teamID) {
        return this.http.get(`/team/${teamID}/managers`)
    }

    remember(data) {
        return this.http.post('/offline/remember', data)
    }
    cep(zipCode) {
        return this.http.get(`cep/zipCode/${zipCode}`)
    }
}
